import {Component, Inject, LOCALE_ID, OnInit} from '@angular/core';
import {AbstractPopupComponent} from "../../../abstract-popup-component";
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'kiwi-support-popup',
    templateUrl: './support-popup.component.html',
    styleUrls: ['./support-popup.component.scss'],
    host: { 'class': 'popupContainer' },
    standalone: false
})
export class SupportPopupComponent extends AbstractPopupComponent {
    public readonly userGuideLink: string;

    constructor(translateService: TranslateService) {
        super();
        this.userGuideLink = `/static/userGuide/kiwi/${translateService.currentLang}/user-guide.pdf`
    }

}
